module.exports = __webpack_public_path__ + "img/river.b7123c55.gif";